import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CustomerTimeline } from "../../components/timeline";

const CustomerTimelinePage = () => {
  const { customerNo } = useParams<{ customerNo: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const handleWorkClick = (workId: number) => {
    // Navigate to work modal or page
    navigate(`/works/${workId}`, {
      state: {
        background: location,
      },
    });
  };

  const handleWorkItemClick = (workItemId: number) => {
    // Navigate to activity dialog
    console.log("Work item clicked:", workItemId);
    navigate(`/activity/${workItemId}`, {
      state: {
        background: location,
      },
    });
  };

  if (!customerNo) {
    return <div>Ogiltigt kundnummer</div>;
  }

  return (
    <CustomerTimeline
      customerNo={parseInt(customerNo)}
      onWorkClick={handleWorkClick}
      onWorkItemClick={handleWorkItemClick}
    />
  );
};

export default CustomerTimelinePage;
